import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminAudit = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${API}/admin/audit-logs`);
        setLogs(response.data);
      } catch (error) {
        toast.error('Failed to load audit logs');
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="p-8" data-testid="admin-audit-page">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-brand-primary">Audit Logs</h1>
        <p className="text-slate-600 mt-1">{logs.length} logged actions</p>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr className="text-left uppercase text-xs tracking-wider text-slate-600">
              <th className="p-4">Time</th>
              <th className="p-4">Admin</th>
              <th className="p-4">Action</th>
              <th className="p-4">Entity</th>
              <th className="p-4">Previous</th>
              <th className="p-4">New</th>
              <th className="p-4">Reason</th>
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan="7" className="p-8 text-center"><div className="loader mx-auto"></div></td></tr>
              : logs.length === 0 ? <tr><td colSpan="7" className="p-8 text-center text-slate-500">No logs</td></tr>
              : logs.map(log => (
                <tr key={log.id} className="border-t border-slate-100">
                  <td className="p-4 text-xs text-slate-500">{new Date(log.created_at).toLocaleString()}</td>
                  <td className="p-4 text-xs">{log.admin_email}</td>
                  <td className="p-4">
                    <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded text-xs font-semibold">{log.action}</span>
                  </td>
                  <td className="p-4 text-xs">{log.entity_type}<br /><span className="text-slate-400">{log.entity_id?.slice(0, 8)}</span></td>
                  <td className="p-4 text-xs text-slate-600 max-w-xs truncate">{log.previous_value || '-'}</td>
                  <td className="p-4 text-xs text-slate-600 max-w-xs truncate">{log.new_value || '-'}</td>
                  <td className="p-4 text-xs text-slate-600 max-w-xs truncate">{log.reason || '-'}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAudit;
